import React from 'react'
import { BodyText } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'

interface LoadingProps {
  classes?: string
}
const Loading = ({ classes = '' }: LoadingProps) => {
  return (
    <>
      <BodyText
        isLoading
        className={`${styles.loading} ${styles.w50} ${styles[classes]}`}
      />
      <BodyText isLoading className={`${styles.loading} ${styles[classes]}`} />
      <BodyText isLoading className={`${styles.loading} ${styles[classes]}`} />
      <BodyText isLoading className={`${styles.loading} ${styles[classes]}`} />
      <BodyText
        isLoading
        className={`${styles.loading} ${styles.w25} ${styles[classes]}`}
      />
    </>
  )
}
export default Loading
